import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class DeluxePlayerPanelSelectorComponent extends Component {
  @service settings;

  @action
  onSelect(value) {
    this.settings.selectedPanel = value;
  }
}
